import React, { useState, useEffect } from 'react'

interface IAutologout {
  timeout?: number
  callback: () => void
}
const AutoLogout = ({ callback, timeout = 300000 }: IAutologout) => {
  const [lastActivityTime, setLastActivityTime] = useState(Date.now())

  const resetTimeout = () => {
    setLastActivityTime(Date.now())
  }

  useEffect(() => {
    const events = ['mousemove', 'keypress', 'scroll', 'click']
    events.forEach((event) => window.addEventListener(event, resetTimeout))

    const interval = setInterval(() => {
      if (Date.now() - lastActivityTime > timeout) {
        callback()
      }
    }, 1000)

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimeout))
      clearInterval(interval)
    }
  }, [lastActivityTime, timeout, callback])

  return null
}

export default AutoLogout
